export default __webpack_public_path__ + "static/dx-local-dev-b074ae26a560e165266e1ba656194413.png";